// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"Button_button-wrapper__8zNEx","about-page-button":"Button_about-page-button__X2h9c","footer2":"Button_footer2__pP9VQ"};